import React, { FunctionComponent } from 'react';
import type { SelectOption } from './types';

type Props = {
  employmentTypes: SelectOption[];
  occupations: SelectOption[];
  prefectures: SelectOption[];
};

export const Presentation: FunctionComponent<Props> = ({
  employmentTypes,
  occupations,
  prefectures,
}) => {
  return (
    <section className="sitetop-recruitment">
      <div className="section-title">
        <h2 className="section-title__main">
          SEARCH<span className="section-title__main--sub">条件から探す</span>
        </h2>
      </div>
      <div className="search-content">
        <form action="/search" method="get" name="form">
          <input type="hidden" name="status" value="without_login" />
          <div className="search-box">
            <select name="employment_type" className="search-box__select" defaultValue="">
              <option value="">雇用形態</option>
              {employmentTypes.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <select name="occupation_id" className="search-box__select" defaultValue="">
              <option value="">職種</option>
              {occupations.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <select name="prefecture_ids" className="search-box__select" defaultValue="">
              <option value="">地域</option>
              {prefectures.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
          <button type="submit" name="" className="search-button">
            <i className="fas fa-search submit-icon" />
            <span className="submit-text">検索</span>
          </button>
        </form>
      </div>
    </section>
  );
};
